<template>
  <div class="img_list">
    <div v-for="(items, index) in imageList" class="img">
      <cc-uploader
        :config="uploaderConf"
        fType="image"
        v-model="items.url"
        :fFormatV2="['.png', '.jpg']"
        :maxFSize="200"
      />
      <el-button
        type="danger"
        icon="el-icon-delete"
        circle
        size="mini"
        class="deleteImgList"
        @click="deleteImgList(index)"
      ></el-button>
    </div>
    <el-button @click="addImgList" size="mini">Add Image</el-button>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";

export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      uploaderConf: {},
      imageList: [],
      index: 1,
    };
  },
  watch: {
    formData: {
      handler() {
        if (this.formData.imageList && this.index == 1) {
          try {
            let imageList = JSON.parse(this.formData.imageList);
            for (let i = 0; i < imageList.length; i++) {
              this.imageList.push({ url: imageList[i] });
            }
            this.index = 2;
          } catch (e) {
            console.log(e);
          }
        }
        this.uploaderConf = uploadUtils.configPublishV2(
          "/perm/sisProduct/" + this.formData.shopNum + "/"
        );
      },
      deep: true,
      immediate: true,
    },
    imageList: {
      handler() {
        let imageList = [];
        for (let i = 0; i < this.imageList.length; i++) {
          if (this.imageList[i].url) {
            imageList.push(this.imageList[i].url);
          }
        }
        this.$emit("change", JSON.stringify(imageList));
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addImgList() {
      this.imageList.push({ url: "" });
    },
    deleteImgList(index) {
      this.imageList.splice(index, 1);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.img {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  width: 100%;
}
.deleteImgList {
  margin-left: 10px;
}
</style>
